<template>
	<div class="info-content">
		<el-form label-width="80px">
			<el-form-item label="按钮文字">
				<el-input type="textarea" :rows="4" v-model="list.content"></el-input>
			</el-form-item>
			<el-form-item label="按钮颜色">
				<el-color-picker v-model="list.textColor" show-alpha></el-color-picker>
			</el-form-item>
			<el-form-item label="按钮背景">
				<el-color-picker v-model="list.textBackgroundColor" show-alpha></el-color-picker>
			</el-form-item>
			<el-form-item label="提交类型">
				<el-radio v-model="list.subType" label="SK">送课</el-radio>
				<el-radio v-model="list.subType" label="AISZ">AI舌诊</el-radio>
			</el-form-item>
			<el-form-item label="外边距">
				<el-input-number v-model="list.marginTop" placeholder="单位像素（px）" controls-position="right" :step="2" step-strictly></el-input-number>
			</el-form-item>
			<el-form-item label="内边距">
				<el-input-number v-model="list.paddingTop" placeholder="单位像素（px）" controls-position="right" :step="2" step-strictly></el-input-number>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
export default {
	name: 'button_config',
	props: ['data', 'className'],
	data() {
		return {
			list: {},
		};
	},
	mounted() {
		console.log(this.data);
		this.list = this.data;
		// this.list.subType = this.list.subType == undefined ? 'SK' : this.list.subType;
	},
};
</script>

<style lang="scss" scoped>
.info-content {
	padding: 20px;
}
.el-input-number {
	width: 220px;
}
</style>